// =====================================================
// CONFIGURAÇÕES DO SITE - ATUALIZE COM SEUS DADOS REAIS
// =====================================================

export const siteConfig = {
  // Informações Pessoais
  name: 'Cássio Lemos - Portfólio 2026',
  title: 'Diretor de Arte & Designer Gráfico',
  location: 'Rio de Janeiro, Brasil',

  // Contato
  email: 'contato@cassiodesign.com.br',
  phone: '+55 (21) 99999-9999',
  whatsapp: '5521999999999', // Apenas números, sem espaços ou símbolos

  // Redes Sociais
  social: {
    linkedin: 'https://linkedin.com/in/cassiodesign',
    instagram: 'https://instagram.com/cassiodesign',
    behance: 'https://behance.net/cassiodesign',
    dribbble: 'https://dribbble.com/cassiodesign',
  },

  // URLs do Site
  siteUrl: 'https://cassio.design',
  ogImage: 'https://cassio.design/og-image.jpg',

  // Horário de Atendimento
  workingHours: [
    { day: 'Segunda a Sexta', hours: '9h às 18h' },
    { day: 'Sábados', hours: 'Sob consulta' },
    { day: 'Domingos', hours: 'Fechado' }
  ],

  // Benefícios (página de contato)
  benefits: [
    'Resposta em até 24h',
    'Consultoria gratuita de 30min',
    'Orçamento personalizado',
    'Flexibilidade de horários'
  ]
};

// Helper para gerar link do WhatsApp
export const getWhatsAppLink = (message?: string) => {
  const baseUrl = `https://wa.me/${siteConfig.whatsapp}`;
  if (message) {
    return `${baseUrl}?text=${encodeURIComponent(message)}`;
  }
  return baseUrl;
};

// Helper para gerar link de email
export const getEmailLink = (subject?: string) => {
  const baseUrl = `mailto:${siteConfig.email}`;
  if (subject) {
    return `${baseUrl}?subject=${encodeURIComponent(subject)}`;
  }
  return baseUrl;
};

// Helper para gerar link de telefone
export const getPhoneLink = () => {
  return `tel:${siteConfig.phone.replace(/\D/g, '')}`;
};
